/**
 * @enum {enumThemeMode} An enumeration of the different theme modes
 */
export enum enumThemeMode {
  Dark = 'dark', // Dark theme mode
  Light = 'light', // Light theme mode
}
